import React, { Component } from "react";
import { PostData } from "../../../service/postData";
import { sendNotification } from "../../../_notificationSettings/notificationPanel";
import ToggleSwitch from "../../../_toggleSwitch/toggleSwitch";
import validator from "validator";

import Modal from "react-modal";
import QuickAddNewBankDetail from "./quickBankAdd";

import moment from "moment";
import DatePicker from "react-datepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

let _signingId = "0";
let _businessId = "0";
let _company_id = "0";
let country_code = "0";
let tax_name = "";
let gstTypeData = [];
let _bankArray = [];
let _countryCode = "IN";
_bankArray.push(
  { bank_id: "0", bank_name: "", paymentType: "Cash" }
  //{ bank_id: "0", bank_name: "", paymentType: "Cheque" }
);

let _loader = "glb-ldr-prt active";
let _isEditMode = false;

export default class partyListPanel extends Component {
  constructor(props) {
    _isEditMode = false;
    super(props);

    //_bankArray.push({"bank_id":"0","bank_name":"","paymentType":"Cash"});

    let _UserSession = localStorage.getItem("vs_UserSession");
    if (_UserSession!=undefined || _UserSession!=null) {
      _UserSession = JSON.parse(_UserSession);
      _signingId = _UserSession.loginId;
    }

    let _companySession = localStorage.getItem("vs_UserCompanySession");
    if (_companySession!=undefined || _companySession!=null) {
      _companySession = JSON.parse(_companySession);
      _businessId = _companySession.business_id;
      _company_id = _companySession.company_id;
      country_code = _companySession.country_code;
      tax_name = _companySession.tax_name;
      gstTypeData = _companySession.taxType;
      //_bankArray = _companySession.bankDetails;
      let bankArrayData = _companySession.bankDetails
        ? _companySession.bankDetails
        : [];
      bankArrayData.map((bank, index) => {
        if (
          !(
            _bankArray.filter((item) => item.bank_name == bank.bank_name)
              .length > 0
          )
        ) {
          _bankArray.push(bank);
        }
      });
    }
    this.state = {
      minDate: this.props.minDate
        ? this.props.minDate
        : [moment().subtract(7, "days")],
      isRedirectTo: this.props.isRedirectTo
        ? this.props.isRedirectTo
        : "business/manage-loan-accounts/",
      buttonTitle: "",
      hideShow: "",
      isLoaded: true,
      company_id: _company_id,
      businessId: _businessId,
      userId: _signingId,
      pay_date: moment().format("YYYY-MM-DD"),
      loanAccountTrasacId: this.props.loanAccountId,
      loanTrasactionId: this.props.loanTrasactionId,
      amount: "",
      received_in: "Cash",
      trasaction_type_name: "",
      bankId: "0",
      bankName: "",

      errors: {
        amount: "",
        received_in: "",
        trasaction_type_name: "",
      },
    };
  }

  async componentDidMount() {
    let _loanTrasacId = this.props.loanTrasactionId;

    if (_loanTrasacId > 0) {
      _isEditMode = true;
      const requestData = JSON.stringify({
        loanTrasacId: _loanTrasacId,
      });

      PostData(global.userLoanAccountTrasactionDetails, requestData, "POST")
        .then((result) => {
          let responseJson = result;
          if (responseJson.success == false) {
            this.setState({ isLoaded: true });
          } else {
            if (responseJson.response) {
              let _transArray = responseJson.response[0];

              this.setState({
                buttonTitle: "Edit",
                loan_detail_id: _transArray.loan_detail_id,
                loan_id: _transArray.loan_id,
                amount: _transArray.amount,
                loan_received: _transArray.loan_received,
                trasaction_type_name: _transArray.trasaction_type_name,
                bankId: _transArray.received_bank_id,
                received_in: _transArray.loan_received,
                pay_date: moment(_transArray.pay_date).format("YYYY-MM-DD"),
                isLoaded: true,
              });
            }
          }
        })
        .catch((error) => this.setState({ error, isLoaded: false }));
    }
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "trasaction_type_name":
        errors.trasaction_type_name =
          value.length < 2 ? "*Enter trasaction type name" : "";
        this.setState({ trasaction_type_name: value });
        break;

      case "amount":
        if (validator.isInt(value)) {
          errors.amount = "";
        } else {
          errors.amount = "*Amount should be numeric!";
        }
        this.setState({ amount: value });
        break;

      case "received_in":
        errors.received_in = value.length < 1 ? "*Select payment type!" : "";
        if (value == "NewBank") {
          this.openModalHandler("modalAdjustNewBank");
        }
        //this.setState({received_in:value});

        let _bankId = 0;
        let _bankName = "";
        let _valType = "";
        if (value > 0) {
          _valType = "Bank";
          var index = event.target.selectedIndex;
          var optionElement = event.target.childNodes[index];

          _bankId = optionElement.getAttribute("data-bankId");
          _bankName = optionElement.getAttribute("data-bankName");
        } else {
          _valType = value;
        }
        //console.log(_bankId+'--'+_bankName+'---'+value+'----'+_valType);
        this.setState({
          received_in: _valType,
          bankId: _bankId,
          bankName: _bankName,
        });
        break;

      default:
        break;
    }
  };

  clickToAddBankDetails = (event) => {
    event.preventDefault();
    let errors = this.state.errors;
    let _isError = false;

    if (this.state.received_in == "") {
      _isError = true;
      errors["received_in"] = "*Please Select Loan Received In";
      this.setState({ errors: errors });
    }
    if (this.state.trasaction_type_name == "") {
      _isError = true;
      errors["trasaction_type_name"] = "*Please Enter trasaction type name";
      this.setState({ errors: errors });
    }
    if (this.state.amount == "") {
      _isError = true;
      errors["amount"] = "*Please Enter amount.";
      this.setState({ errors: errors });
    }

    if (_isError == false) {
      if (this.state.loanTrasactionId > 0) {
        this.editLoanTrasacDMethodCall();
      } else {
        this.addLoanTrasacDMethodCall();
      }
      //this.addLoanTrasacDMethodCall();
    }
  };

  settleAmountType() {
    let _payData = [];
    if (this.state.isLoaded == true) {
      if (_bankArray.length > 0) {
        _bankArray.map((bankD, index) => {
          let _arrayLength = _bankArray.length;
          let _valOption = bankD.paymentType;
          let _disOption = bankD.paymentType;
          let _isBankExist = 0;
          if (bankD.bank_id > 0) {
            _isBankExist = 1;
            _valOption = bankD.bank_id;
            _disOption = bankD.bank_name;
          }

          let _selBank = "";
          if (bankD.bank_id > 0) {
            if (_valOption == this.state.received_bank_id) {
              _selBank = "selected";
            }
          } else {
            if (_valOption == this.state.loan_received) {
              _selBank = "selected";
            }
          }

          if (
            _valOption > 0 ||
            _disOption == "Cash" ||
            _disOption == "Cheque"
          ) {
            _payData.push(
              <option
                value={_valOption}
                selected={_selBank}
                data-bankName={_disOption}
                data-bankId={_valOption}
              >
                {_disOption}
              </option>
            );
          }

          let _addNewBank = "";
          if (_arrayLength == index + 1) {
            if (_isBankExist == 0) {
              _payData.push(<option value="NewBank">Add New Bank</option>);
            }
          }
        });
      } else {
        return <option value="NewBank">Add New Bank</option>;
      }
    }
    return _payData;
  }

  settleAmountTypeOld() {
    let _payData = [];
    if (this.state.isLoaded == true) {
      if (_bankArray.length > 0) {
        _bankArray.map((bankD, index) => {
          let _arrayLength = _bankArray.length;
          let _valOption = bankD.paymentType;
          let _disOption = bankD.paymentType;
          let _isBankExist = 0;

          if (bankD.bank_id > 0) {
            _isBankExist = 1;
            _valOption = bankD.bank_id;
            _disOption = bankD.bank_name;
          }

          let _selBank = "";
          if (bankD.bank_id > 0) {
            if (_valOption == this.state.bankId) {
              _selBank = "selected";
            }
          } else {
            if (_valOption == this.state.received_in) {
              _selBank = "selected";
            }
          }

          if (
            _valOption > 0 ||
            _disOption == "Cash" ||
            _disOption == "Cheque"
          ) {
            _payData.push(
              <option
                value={_valOption}
                selected={_selBank}
                data-bankName={_disOption}
                data-bankId={_valOption}
              >
                {_disOption}
              </option>
            );
          }

          let _addNewBank = "";
          if (_arrayLength == index + 1) {
            if (_isBankExist == 0) {
              _payData.push(<option value="NewBank">Add New Bank</option>);
            }
          }
        });
      } else {
        return <option value="NewBank">Add New Bank</option>;
      }
    }
    return _payData;
  }

  addLoanTrasacDMethodCall() {
    const requestData = JSON.stringify({
      company_id: this.state.company_id,
      businessId: this.state.businessId,
      userId: this.state.userId,
      loan_id: this.state.loanAccountTrasacId,
      amount: this.state.amount,
      received_in: this.state.received_in,
      trasaction_type_name: this.state.trasaction_type_name,
      bankId: this.state.bankId,
      bankName: this.state.bankName,
      pay_date: moment(this.state.pay_date).format("YYYY-MM-DD"),
    });
    PostData(global.userAddLoanChargesAmount, requestData, "POST").then(
      (result) => {
        if (result.success == true) {
          sendNotification("Success Message 👍", result.message, "success");
          setTimeout(() => {
            this.props.callBack("hello");
          }, Math.floor(Math.random() * 5000) + 1);
        } else {
          sendNotification("Error Message 😓", result.message, "danger");
          return;
        }
      }
    );
  }

  editLoanTrasacDMethodCall() {
    const requestData = JSON.stringify({
      company_id: this.state.company_id,
      businessId: this.state.businessId,
      userId: this.state.userId,
      loan_detail_id: this.state.loanTrasactionId,
      loan_id: this.state.loanAccountTrasacId,
      amount: this.state.amount,
      received_in: this.state.received_in,
      trasaction_type_name: this.state.trasaction_type_name,
      bankId: this.state.bankId,
      bankName: this.state.bankName,
      pay_date: moment(this.state.pay_date).format("YYYY-MM-DD"),
    });
    PostData(global.userEditLoanChargeAmount, requestData, "POST").then(
      (result) => {
        if (result.success == true) {
          sendNotification("Success Message 👍", result.message, "success");
          setTimeout(() => {
            this.props.callBack("hello");
          }, Math.floor(Math.random() * 5000) + 1);
        } else {
          sendNotification("Error Message 😓", result.message, "danger");
          return;
        }
      }
    );
  }

  /*For Modal open close*/
  openModalHandler(e) {
    if (e == "modalAdjustNewBank") {
      this.setState({ modalIsOpen_SBANK: true });
    }
  }
  closeModalHandler = (e) => {
    if (e == "modalAdjustNewBank") {
      this.setState({ modalIsOpen_SBANK: false });
    }
  };
  /*End Modal open close*/
  handleCallBackDate = (start) => {
    this.setState({ pay_date: start.format("YYYY-MM-DD") });
  };

  isDateRefresh = () => {
    let _invoiceDate = this.state.pay_date;
    let _given = moment(this.state.minDate, "YYYY-MM-DD");
    let _current = moment().startOf("day");
    let _remianDays =
      moment.duration(_given.diff(_current)).asDays() < 0
        ? moment.duration(_given.diff(_current)).asDays()
        : 7;
    _remianDays = Math.abs(_remianDays);

    const slectedDate = moment(_invoiceDate).toDate();
        return (
          <DatePicker
            minDate={new Date(_given)}
            selected={slectedDate}
            className="form-control search-box"
            onChange={date => this.setState({ pay_date: moment(date).format("YYYY-MM-DD") })}
            showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          />
        );

  };

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }

    const { errors } = this.state;
    const isDisabled = Object.keys(errors).some((x) => errors[x]);
    return (
      <React.Fragment>
        <form method="post" id="form-login" className="webForm px-30">
          <div className="form-group row">
            <div className="col-3">
              <div className="form-material open">
                <input
                  type="text"
                  required="required"
                  className="form-control"
                  id="trasaction_type_name"
                  name="trasaction_type_name"
                  value={this.state.trasaction_type_name}
                  placeholder="Enter Transaction Type Name"
                  onChange={this.handleChange}
                />
                <label htmlFor="login-username">
                  Transaction Type Name <span className="text-danger">*</span>
                </label>
                <span className="iris_error_txt">
                  {errors.trasaction_type_name.length > 0 && (
                    <span className="error">{errors.trasaction_type_name}</span>
                  )}
                </span>
              </div>
            </div>
            <div className="col-3">
              <div className="form-material open">
                <input
                  type="text"
                  required="required"
                  className="form-control"
                  id="amount"
                  name="amount"
                  value={this.state.amount}
                  placeholder="Enter Amount"
                  onChange={this.handleChange}
                />
                <label htmlFor="login-username">
                  Enter Amount <span className="text-danger">*</span>
                </label>
                <span className="iris_error_txt">
                  {errors.amount.length > 0 && (
                    <span className="error">{errors.amount}</span>
                  )}
                </span>
              </div>
            </div>
            <div className="col-3">
              <div className="form-material open">
                <select
                  name="received_in"
                  defaultValue={
                    this.state.bankId > 0
                      ? this.state.bankId
                      : this.state.received_in
                  }
                  id="received_in"
                  className="form-control"
                  onChange={this.handleChange}
                >
                  {this.settleAmountType()}
                </select>
                <label htmlFor="login-username">Paid From</label>
                <span className="iris_error_txt">
                  {errors.received_in.length > 0 && (
                    <span className="error">{errors.received_in}</span>
                  )}
                </span>
              </div>
            </div>
            <div className="col-3">
              <div className="form-material open">
                {this.isDateRefresh()}
                <label htmlFor="login-username">Pay Date</label>
              </div>
            </div>
          </div>
          <div className="claerfix"></div>

          <div className="claerfix"></div>
          <div className="form-group row">
            <div className="col-12">
              <button
                type="submit"
                className="btn btn-alt-primary"
                onClick={this.clickToAddBankDetails}
                disabled={isDisabled}
              >
                <i className="fa fa-check mr-5"></i> Save
              </button>
            </div>
          </div>
        </form>

        {/* Modal Add Bank Details Begins */}
        <Modal
          isOpen={this.state.modalIsOpen_SBANK}
          ariaHideApp={false}
          size="sm"
          aria-labelledby="modal-popout"
          onRequestClose={this.closeModalHandler}
          id="modalAdjustNewBank"
        >
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="block block-themed block-transparent mb-0">
                <div className="block-header bg-primary-dark">
                  <h3 className="block-title">Add New Bank</h3>
                  <div className="block-options">
                    <button
                      type="button"
                      className="btn-block-option"
                      onClick={this.closeModalHandler.bind(
                        this,
                        "modalAdjustNewBank"
                      )}
                    >
                      <i className="si si-close"></i>
                    </button>
                  </div>
                </div>
                <div className="block-content">
                  <QuickAddNewBankDetail isRedirectTo={"business/add-sale/"} />
                </div>
                <br />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-alt-secondary"
                  onClick={this.closeModalHandler.bind(
                    this,
                    "modalAdjustNewBank"
                  )}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
        {/* Modal Add Bank Details*/}
      </React.Fragment>
    );
  }
}
